<template>
  <v-row class="tipo-interacao-bio-panel">
    <!-- user profile -->
    <v-col cols="12">
      <v-card class="pt-10">
        <v-card-text class="d-flex justify-center">
          <v-icon
            size="100"
          >
            {{ icons.mdiPlusBoxMultiple }}
          </v-icon>
        </v-card-text>

        <v-card-title class="justify-center flex-column">
          <v-chip
            label
            small
            :class="`v-chip-light-bg text-sm font-weight-semibold --text text-capitalize`"
          >
            {{ filas.nome }}
          </v-chip>
        </v-card-title>

        <v-card-text>
          <h2 class="text-xl font-weight-semibold mb-2">
            Informações
          </h2>

          <v-divider></v-divider>

          <v-list>
            <v-list-item
              dense
              class="px-0 mb-n2"
            >
              <span class="font-weight-medium text-no-wrap me-2">Descrição:</span>
              <span class="text--secondary">{{ filas.descricao }}</span>
            </v-list-item>

            <v-list-item
              dense
              class="px-0 mb-n2"
            >
              <span class="font-weight-medium text-no-wrap me-2">Máx tickets por agente:</span>
              <span class="text--secondary">{{ filas.maxTicketsPorAgente }}</span>
            </v-list-item>

            <v-list-item
              dense
              class="px-0 mb-n2"
            >
              <span class="font-weight-medium text-no-wrap me-2">Agrupar tickets desta fila:</span>
              <span class="text--secondary">{{ filas.isAgrupado ? 'Sim' : 'Não' }}</span>
            </v-list-item>

            <v-list-item
              dense
              class="px-0 mb-n2"
            >
              <span class="font-weight-medium text-no-wrap me-2">Permitir agendamento?:</span>
              <span class="text--secondary">{{ filas.permitirAgendamento ? 'Sim' : 'Não' }}</span>
            </v-list-item>

            <v-list-item
              dense
              class="px-0 mb-n2"
            >
              <span class="font-weight-medium text-no-wrap me-2">Status:</span>
              <v-chip
                v-if="filas.statusNome === 'Ativa'"
                small
                class="ml-2"
                color="success"
                outlined
              >
                {{ filas.statusNome }}
              </v-chip>
              <v-chip
                v-else-if="filas.statusNome === 'Inativa'"
                small
                class="ml-2"
                color="error"
                outlined
              >
                {{ filas.statusNome }}
              </v-chip>
              <v-chip
                v-else
                small
                class="ml-2"
                color="primary"
                outlined
              >
                {{ filas.statusNome }}
              </v-chip>
            </v-list-item>
          </v-list>
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn
            v-if="filas.statusId !== 3 && !acessoPut"
            color="primary"
            class="me-3"
            disabled
          >
            Editar
          </v-btn>
          <v-btn
            v-else
            color="primary"
            class="me-3"
            @click="isInfoDialogOpen = !isInfoDialogOpen"
          >
            Editar
          </v-btn>

          <v-btn
            v-if="!acessoDisable"
            :color="filas.statusId === 2 ? 'error' : 'success'"
            class="me-3"
            outlined
            disabled
          >
            <span> {{ filas.statusNome === 'Ativa' ? 'Inativar' : 'Ativar' }} </span>
          </v-btn>
          <v-btn
            v-else
            :color="filas.statusId === 2 ? 'error' : 'success'"
            class="me-3"
            outlined
            @click="deleteItem(filas)"
          >
            <span> {{ filas.statusNome === 'Ativa' ? 'Inativar' : 'Ativar' }} </span>
          </v-btn>
        </v-card-actions>
      </v-card>

      <!-- dialog ativar / inativar -->
      <v-dialog
        v-model="dialogDelete"
        max-width="500px"
        persistent
      >
        <v-card>
          <v-card-title class="headline">
            {{ `${inativar.ativar === 'Ativa' ? 'Inativar' : 'Ativar'}` }}
          </v-card-title>
          <v-card-text> {{ `Tem certeza que deseja ${inativar.ativar === 'Ativa' ? 'inativar' : 'ativar'} esta fila?` }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error"
              outlined
              @click="dialogDelete = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="success"
              @click="alterarStatus()"
            >
              <v-progress-circular
                v-if="loadings"
                indeterminate
                color="secundary"
              ></v-progress-circular>
              <span v-else>OK</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- edit profile dialog data -->
      <fila-info-edit
        :fila-data="filas"
        :is-info-dialog-open.sync="isInfoDialogOpen"
        @refetch-data="$emit('refetch-data')"
      ></fila-info-edit>
    </v-col>
  </v-row>
</template>

<script>
import { avatarText, kFormatter } from '@core/utils/filter'
import {
  mdiBriefcaseVariantOutline, mdiCheck, mdiCheckboxBlankCircle, mdiPlusBoxMultiple,
} from '@mdi/js'
import { ref } from '@vue/composition-api'
import FilaInfoEdit from './FilaInfoEdit.vue'
import router from '@/router'
import FilaService from '@/services/modules/FilaService'

export default {
  components: {
    FilaInfoEdit,
  },
  props: {
    filas: {
      type: Object,
      default: () => {},
    },
    acessoPut: {
      type: Boolean,
      default: () => true,
    },
    acessoDisable: {
      type: Boolean,
      default: () => true,
    },
  },

  setup(props, { emit }) {
    const isInfoDialogOpen = ref(false)

    const inativar = {
      ativar: null,
    }
    const dialogDelete = ref(false)
    const loadings = ref(false)

    // this.dialogInativar = false
    const deleteItem = filas => {
      dialogDelete.value = true
      // eslint-disable-next-line no-unused-expressions
      filas.statusId === 2 ? inativar.ativar = false : inativar.ativar = true
    }

    const alterarStatus = async () => {
      try {
        loadings.value = !loadings.value

        await FilaService.ativarOuInativar(router.currentRoute.params.id, inativar)

        emit('refetch-data')
        loadings.value = !loadings.value
        dialogDelete.value = !dialogDelete.value
      } catch {
        loadings.value = !loadings.value
      }
    }

    return {
      avatarText,
      kFormatter,
      isInfoDialogOpen,
      alterarStatus,
      inativar,
      deleteItem,
      dialogDelete,
      loadings,
      icons: {
        mdiCheck,
        mdiBriefcaseVariantOutline,
        mdiCheckboxBlankCircle,
        mdiPlusBoxMultiple,
      },
    }
  },
}
</script>
